import { useEffect } from "react";
import { useErrors } from "../contexts/ErrorContext";

/**
 * Intercepts console.error calls and funnels them into the ErrorContext
 * so users with the `view_error_details` role see them as toasts.
 *
 * Ported from Captain's Log.
 */
export function useErrorInterceptor(): void {
  const { addError, canViewErrors } = useErrors();

  useEffect(() => {
    if (!canViewErrors) return;

    const originalError = console.error;

    console.error = (...args: unknown[]) => {
      originalError.apply(console, args as []);

      const errorArg = args[0];
      let error: Error;
      if (errorArg instanceof Error) {
        error = errorArg;
      } else {
        error = new Error(args.map((a) => String(a)).join(" "));
      }

      addError(error);
    };

    return () => {
      console.error = originalError;
    };
  }, [addError, canViewErrors]);
}
